import GameBanner from './GameBanner';
export default GameBanner;
